import type { ReactNode } from 'react';

interface LandingSectionProps {
  id: string;
  topBorder?: boolean;
  bg?: 'default' | 'muted';
  children: ReactNode;
}

export default function LandingSection({
  id,
  topBorder = false,
  bg = 'default',
  children,
}: LandingSectionProps) {
  const classes = [
    'flex min-h-[calc(100vh-4rem)] items-center',
    topBorder ? 'border-t border-border' : '',
    bg === 'muted' ? 'bg-muted' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <section id={id} className={classes}>
      <div className="mx-auto w-full max-w-6xl px-4 py-16 sm:px-6 lg:px-8">
        {children}
      </div>
    </section>
  );
}
